// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import "./CreateFolderModal.css";
// import { useNavigate } from "react-router-dom";
// import Cookies from "js-cookie";
// import api from "../chat/api";
// import { toast, ToastContainer } from "react-toastify";
// import 'react-toastify/dist/ReactToastify.css';

// import { getFreshAccessToken } from "../chat/api";
// const CreateFolderModal = ({ isOpen, onClose }) => {
//   const [isUploading, setIsUploading] = useState(false);
//   const [isUploaded, setIsUploaded] = useState(false);
//   const [invoiceKey, setInvoiceKey] = useState(null);
//   const [fileKey, setFileKey] = useState(null);
//   const [progress, setProgress] = useState(0);
//   let progressInterval = null;
//  const [fileStatusMap, setFileStatusMap] = useState({});
// const claimedKeysRef = useRef(new Set());
// const [isCreating, setIsCreating] = useState(false);

//   const [uploadController, setUploadController] = useState(null);
//   const [messages, setMessages] = useState([]);
//   const [connectionStatus, setConnectionStatus] = useState("Disconnected");
//   const [isCanceled, setIsCanceled] = useState(false);
//   const [isDragOver, setIsDragOver] = useState(false);
//   const fileInputRef = useRef(null);

//   const [currentMessage, setCurrentMessage] = useState(
//     "Waiting for updates..."
//   );
//   const [isInvoiceInsideContract, setIsInvoiceInsideContract] = useState(false);
//   const [isContractInsideInvoice, setIsContractInsideInvoice] = useState(false);
//   const [wsStatusMessage, setWsStatusMessage] = useState("Waiting for updates...");
//   // const uploadSocketRef = useRef(null);

//   const [istrue, setIstrue] = useState(true);


// /** one entry per chosen file  */
// const [files, setFiles] = useState([]);

// /** quick enum so we don’t mistype strings */
// const STATUS = { PENDING:'pending', UPLOADING:'uploading', SUCCESS:'success', ERROR:'error' };




  

 
// const [folderName, setFolderName] = useState("");


// useEffect(() => {
//   if (isOpen) {
//     // Reset when modal is opened
//     setFiles([]);
//     setProgress(0);
//     setShowErrorPopup(false);
//     setErrorMessage("");
//     setIsUploaded(false);
//     setIsUploading(false);
//     setInvoiceKey(null);
//     setFileKey(null);
//     setCurrentMessage("Waiting for updates...");
//     setWsStatusMessage("Waiting for updates...");
//     setContractKey(null);
//     setIsInvoiceInsideContract(false);
//     setIsContractInsideInvoice(false);
//     setIsCreating(false);  // ✅ Add this too
//     setFolderName("");     // ✅ Optionally reset folder name
//   } else {
//     // Reset if needed when modal is closed
//     setFiles([]);
//     setIsUploaded(false);
//     setIsCreating(false); // ✅ This forces it to NOT show upload UI again
//   }
// }, [isOpen]);


// async function startBatchUpload(fileList) {
//   const formData = new FormData();
//   fileList.forEach(f => formData.append("files", f.file));
//   formData.append("folder_name", folderName);

//   const token = await getFreshAccessToken();
//   const url = `${process.env.REACT_APP_API_URL}api/v1/readpdf/create-folder/`; // ✅ CHANGE THIS

//   const ws = new WebSocket(`${process.env.REACT_APP_WS_URL}/ws/upload-status/?token=${token}`);
 

// ws.onmessage = (e) => {
//   const d = JSON.parse(e.data);

// setFiles(prevFiles => {
//   let alreadyClaimed = false;

//   const updatedFiles = prevFiles.map((f, i) => {
//     const isKeyMatch = f.key === d.pdf_key;

//     const canClaim =
//       !alreadyClaimed &&
//       !f.key &&
//       f.status === STATUS.UPLOADING &&
//       d.pdf_key &&
//       !prevFiles.some((other, idx) => other.key === d.pdf_key && idx !== i);

//     if (!isKeyMatch && !canClaim) return f;

//     const patch = {};

//     if (canClaim) {
//       patch.key = d.pdf_key;
//       alreadyClaimed = true;
//     }

//     if (d.type === "progress") {
//       patch.progress = d.progress;
//     } else if (d.type === "completed") {
//       patch.status = STATUS.SUCCESS;
//       patch.progress = 100;
//     } else if (d.type === "error") {
//       patch.status = STATUS.ERROR;
//       patch.progress = 0;
//     const msg = d.message?.toLowerCase() || "";

//   if (msg.includes("unsupported")) {
//     patch.errorReason = "unsupported";
//   } else if (msg.includes("duplicate")) {
//     patch.errorReason = "duplicate";
//   } else if (msg.includes("size") || msg.includes("limit")) {
//     patch.errorReason = "size_limit";
//   } else {
//     patch.errorReason = "unknown";
//   }
//     }

//     return { ...f, ...patch };
//   });

//   const allDone = updatedFiles.every(
//     f => f.status === STATUS.SUCCESS || f.status === STATUS.ERROR
//   );
//   if (allDone) {
//   if (ws.readyState === WebSocket.OPEN) {
//     ws.close();
//   }
//   setIsUploaded(true); // ✅ always set this, even if ws is already closed
// }
//   return updatedFiles;
// });







// };





//   try {
//     updateAllFilesStatus(STATUS.UPLOADING);

//     const resp = await api.post(url, formData, {
//       headers: { "Content-Type": "multipart/form-data" },
//      onUploadProgress: (ev) => {
//   const baseProgress = Math.min(30, Math.round((ev.loaded * 100) / ev.total));
//   setFiles(prev => prev.map(f => {
//     return { ...f, progress: Math.max(f.progress, baseProgress) };
//   }));
// },

//     });

//     const uploads = resp.data?.uploads || [];

// setFiles(prevFiles =>
//   prevFiles.map(f => {
//     const upload = uploads.find(u => u.filename === f.file.name);
//     return upload && upload.pdf_key
//       ? { ...f, key: upload.pdf_key }
//       : f;
//   })
// );


// }  catch (err) {
//   console.error("🚨 Batch upload failed:", err);
//   setFiles(prev => prev.map(f => ({ ...f, status: STATUS.ERROR })));
//   if (ws.readyState === WebSocket.OPEN) {
//     ws.close();
//   }

//   const backendMsg =
//     err?.response?.data?.msg || err?.response?.data?.error || "Upload failed.";

//   // ✅ Check for folder already exists
//   if (backendMsg.toLowerCase().includes("folder name already exists")) {
//     toast.error(backendMsg); // Show exact backend message
//     setIsCreating(false);    // Reset to initial state
//     setIsUploaded(false);
//     return;                  // Stop further processing
//   }

//   // ✅ Trial user limit
//   if (
//     backendMsg === "Only 5 files allowed" ||
//     backendMsg.includes("Trial users can upload only 5 documents")
//   ) {
//     toast.error(backendMsg);
//     setTimeout(() => {
//       onClose();
//     }, 3000);
//   } else {
//     // Fallback error
//     toast.error(backendMsg);
//     setIsCreating(false);
//     setIsUploaded(false);
//   }
// }


// }

// function updateAllFilesStatus(status) {
//   setFiles(prev => prev.map(f => ({ ...f, status })));
// }




// const handleFileChange = (e) => {
//   const picked = Array.from(e.target.files || []);
//   if (!picked.length) return;

//   const meta = picked.map(f => ({
//     file: f,
//     progress: 0,
//     status: STATUS.PENDING,
//     key: null,
//     ws: null,
//   }));

//   const newFiles = [...files, ...meta];
//   setFiles(newFiles);
  
//   // ✅ This triggers the uploading view
//   setIsCreating(true);
//   setIsUploaded(false);
  
//   startBatchUpload(meta);
// };


  


// const updateFile = (idx, patchOrFn) =>
//   setFiles(prev => prev.map((f, i) =>
//     i === idx
//       ? typeof patchOrFn === "function" ? { ...f, ...patchOrFn(f) } : { ...f, ...patchOrFn }
//       : f
//   ));






  



//   const [showErrorPopup, setShowErrorPopup] = useState(false);
// const [errorMessage, setErrorMessage] = useState("");


// const showError = (message) => {
//   setErrorMessage(message);
//   setShowErrorPopup(true);
// };


//   const navigate = useNavigate();
//   const [contractKey, setContractKey] = useState(null);

//   if (!isOpen) return null;

// const triggerFileInput = () => {
//   if (!folderName.trim()) {
//     toast.error("Please enter a folder name first.");
//     return;
//   }

//   if (fileInputRef.current) {
//     fileInputRef.current.value = null;  // ← force re-trigger
//     fileInputRef.current.click();
//   }
// };


  

//   //   if (isContractInsideInvoice) {
//   //     const keyToUse = files.find(f => f.status === STATUS.SUCCESS)?.key;
//   //     if (!keyToUse) {
//   //       showError("Contract key is missing. Please try again.");
//   //       return;
//   //     }
//   //     navigate("/Contract/contract-details", {
//   //       state: { contractKey: keyToUse, pdfFile: file },
//   //     });
//   //   } else if (type === "Invoices" || isInvoiceInsideContract) {
//   //     const keyToUse = invoiceKey || contractKey;
//   //     if (!keyToUse) {
//   //       showError("Invoice key is missing. Please try again.");
//   //       return;
//   //     }
//   //     navigate("/Invoices/Invoice_Details", {
//   //       state: {
//   //         invoiceKey: keyToUse,
//   //         pdfFile: file,
//   //         additionalInfo: "Invoice uploaded via contract flow",
//   //       },
//   //     });
//   //   } else if (type === "contract") {
//   //     const keyToUse = contractKey;
//   //     if (!keyToUse) {
//   //       showError("Contract key is missing. Please try again.");
//   //       return;
//   //     }
//   //     navigate("/Contract/contract-details", {
//   //       state: { contractKey: keyToUse, pdfFile: file },
//   //     });
//   //   }
//   // };
  
  
  
  


// const handleClose = () => {
//   // Reset these here too just to be safe
//   setFiles([]);
//   setIsCreating(false);
//   setIsUploaded(false);
//   setFolderName("");

//   onClose();
//   navigate("/uploadFile");  // or conditionally to other routes
// };


// return (
// <div
//   className="fixed inset-0 z-50"
//   style={{
//     backdropFilter: "blur(1.5px)",
//     WebkitBackdropFilter: "blur(1.5px)",
//   }}
//   onClick={handleClose}
// >

//     {isUploaded ? (
// <div
//   className="modal-container-first"
//   onClick={(e) => e.stopPropagation()}
// >
//         <button className="modal-close" onClick={handleClose}>x</button>
//         <h2 className="modal-title">Folder created Successfully</h2>
//         {/* <p className="modal-description">
//           Name your folder and Click to upload your files to organize them right away
//         </p> */}

//         <div className="input-group">
//           <label htmlFor="folderName">Title</label>
//           <input
//             type="text"
//             id="folderName"
//             value={folderName}
//             onChange={(e) => setFolderName(e.target.value)}
//             placeholder="Enter here"
//           />
//         </div>

//         <div className="progress-bar-border scrollbar-thin scrollbar-thumb-[rgba(115,96,123,0.4)] scrollbar-track-transparent ml-2 mt-10" style={{ height: Math.min(files.length * 62, 186), maxHeight: "186px", overflowY: files.length * 62 > 186 ? "auto" : "hidden" }}>
//           {files.map((f, i) => {
  

//   return (
//     <div key={i} className="file-info-success w-full mt-2 rounded-md bg-white px-4 py-2">
//       <div className="flex items-center justify-between">
//         <span className="file-name-highlight ml-1">
//           {f.file.name.length > 25
//             ? `${f.file.name.slice(0, 20)}...${f.file.name.slice(-10)}`
//             : f.file.name}
//         </span>
//         <span className="tick-icon">
//           {f.status === STATUS.SUCCESS ? (
//             <img src="/right-success-upload.svg" alt="✔" className="w-5 h-5" />
//           ) : (
//             <span className="tick-icon flex items-center gap-2 text-sm text-red-600">
//               <img src="/cross-icon.svg" alt="✖" className="w-5 h-5" />
//               {f.status === STATUS.ERROR && (
//                 <span className="whitespace-nowrap">
//                   {(f.errorReason || "").toLowerCase() === "unsupported"
//                     ? "Unsupported file type"
//                     : (f.errorReason || "").toLowerCase() === "duplicate"
//                     ? "Duplicate file"
//                     : (f.errorReason || "").toLowerCase() === "size_limit"
//                     ? "File size exceeds limit"
//                     : "Upload failed"}
//                 </span>
//               )}
//             </span>
//           )}
//         </span>
//       </div>
//       <div className="progress-bar-cont-two">
//         <div
//           className="progress-bar-fill-bar ml-[-2]"
//           style={{ width: `${f.progress}%` }}
//         />
//       </div>
//     </div>
//   );
// })}

//         </div>

//         <div className="success-actions-custom">
//           {/* <div className="left-action">
//             <button className="add-more-btn ml-8" onClick={() => document.getElementById("fileInput").click()}>
//               Add More <span>+</span>
//             </button>
//           </div> */}
//           <div className="center-action">
//             <button className="view-docs-btn" onClick={() => handleClose(true)}>Done</button>
//           </div>
//         </div>
//       </div>
//     ) : isCreating ? (
//       <div className="modal-container-first" onClick={(e) => e.stopPropagation()}>
//         <button className="modal-close" onClick={handleClose}>x</button>
//         <div className="title-name">
//           <h2 className="modal-title">Create a new folder</h2>
//         </div>
//         <p className="modal-description">
//           Name your folder and drag & drop documents to organize them right away
//         </p>

//         <div className="input-group">
//           <label htmlFor="folderName">Title</label>
//           <input type="text" id="folderName" value={folderName} placeholder="Enter here" disabled />
//         </div>

//         <div className="progress-bar-border bar-border scrollbar-thin scrollbar-thumb-[rgba(115,96,123,0.4)] scrollbar-track-transparent" style={{ height: Math.min(files.length * 65, 195), maxHeight: "195px", overflowY: files.length * 65 > 195 ? "auto" : "hidden" }}>
          
//           {files.map((f, i) => (
//             <div key={i} className="upload-row flex flex-col justify-center" style={{ height: "50px", marginTop: i === 0 ? "0px" : "12px" }}>
//               <div className="percetange-label-upload">
//                 <span className="file-label">
//                   {f.file.name.length > 25 ? `${f.file.name.slice(0, 20)}...${f.file.name.slice(-10)}` : f.file.name}
//                 </span>
//                 <p className="progress-num">{f.progress}% to complete</p>
//               </div>
//               <div className="progress-bar-cont">
//                 <div className="progress-bar-fill-bar" style={{ width: `${f.progress}%` }} />
//               </div>
//             </div>
//           ))}
//         </div>

//         <div className="flex justify-between items-center mb-2 w-full px-8">
//           <div className="text-sm text-gray-500 font-medium mt-5 ml-[-2]">Supported formats: PDF</div>
//           <div className="text-sm text-gray-500 font-medium mt-5">Maximum Size: 25 MB</div>
//         </div>
//       </div>
//     ) : (
//       <div className="modal-container-two" onClick={(e) => e.stopPropagation()}>
//         <button className="modal-close" onClick={handleClose}>x</button>
//         <h2 className="modal-title">Create a new folder</h2>
//         <p className="modal-description">
//           Name your folder and Click to upload your files to organize them right away
//         </p>

//         <div className="input-group">
//           <label htmlFor="folderName">Title</label>
//           <input type="text" id="folderName" value={folderName} onChange={(e) => setFolderName(e.target.value)} placeholder="Enter here" />
//         </div>

//         <div className={`upload-area ${isDragOver ? "drag-over" : ""}`} 
//         onClick={(e) => {
//   if (e.target.closest("button")) return;
//   if (!folderName.trim()) {
//     toast.error("Please enter a folder name first.");
//     return;
//   }
//   triggerFileInput();

// }}

//         onDragOver={(e) => {
//           e.preventDefault(); setIsDragOver(true);
//         }} onDragLeave={(e) => {
//           e.preventDefault(); setIsDragOver(false);
//         }}
//        onDrop={(e) => {
//   e.preventDefault();
//   setIsDragOver(false);
//   if (!folderName.trim()) {
//     toast.error("Please enter a folder name first.");
//     return;
//   }
//   const droppedFile = e.dataTransfer.files[0];
//   if (droppedFile) {
//     handleFileChange({ target: { files: [droppedFile] } });
//   }
// }}
// >
// <input
//   type="file"
//   id="fileInput"
//   multiple
//   style={{ display: "none" }}
//   ref={fileInputRef}
//   onChange={handleFileChange}
//   disabled={!folderName.trim()}
// />

//           <div className="file-placeholder">
//             <div className="file-icon-folder">
//               <img src="/path-to-file-icon.svg" alt="File Icon" />
//               <img src="/uploadSmall.svg" alt="Overlay Icon" className="upload-small-folder" />
//             </div>
//             <p className="choose-file">
//               {folderName.trim() ? (
//                 <>Click to upload your files or <span className="choose-file-span">Choose File</span></>
//               ) : (
//                 <span style={{ color: "black" }}>Enter folder name to enable upload</span>
//               )}
//             </p>
//             <div className="flex justify-between items-center mb-2 w-full px-8">
//               <div className="text-sm text-gray-500 font-medium mt-5 ml-[-2]">Supported formats: PDF</div>
//               <div className="text-sm text-gray-500 font-medium mt-5">Maximum Size: 25 MB</div>
//             </div>
//             {/* <div className="flex justify-end mt-6">
//               <button style={{ backgroundColor: "#C95EBE" }} className="text-white px-3 py-1 rounded-md shadow hover:bg-blue-700 transition" onClick={() => {
//                 const fileInput = document.getElementById("fileInput");
//                 const selectedFiles = fileInput?.files || [];
//                 if (selectedFiles.length > 0) {
//                   handleFileChange({ target: { files: selectedFiles } });
//                 } else {
//                   toast.error("Please select a file first.");
//                 }
//               }}>
//                 Create Folder
//               </button>
//             </div> */}
//           </div>
//         </div>
//       </div>
//     )}
//   </div>
// );


// };

// export default CreateFolderModal;
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./CreateFolderModal.css";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import api from "../chat/api";
import { toast } from "../../utils/appToast";

import { getFreshAccessToken } from "../chat/api";

const CreateFolderModal = ({ isOpen, onClose }) => {
  const [isUploading, setIsUploading] = useState(false);
  const [isUploaded, setIsUploaded] = useState(false);
  const [invoiceKey, setInvoiceKey] = useState(null);
  const [fileKey, setFileKey] = useState(null);
  const [progress, setProgress] = useState(0);
  let progressInterval = null;
  const [fileStatusMap, setFileStatusMap] = useState({});
  const claimedKeysRef = useRef(new Set());
  const [isCreating, setIsCreating] = useState(false);

  const [uploadController, setUploadController] = useState(null);
  const [messages, setMessages] = useState([]);
  const [connectionStatus, setConnectionStatus] = useState("Disconnected");
  const [isCanceled, setIsCanceled] = useState(false);
  const [isDragOver, setIsDragOver] = useState(false);
  const fileInputRef = useRef(null);

  const [currentMessage, setCurrentMessage] = useState("Waiting for updates...");
  const [isInvoiceInsideContract, setIsInvoiceInsideContract] = useState(false);
  const [isContractInsideInvoice, setIsContractInsideInvoice] = useState(false);
  const [wsStatusMessage, setWsStatusMessage] = useState("Waiting for updates...");

  const [istrue, setIstrue] = useState(true);
  const [files, setFiles] = useState([]);

  const STATUS = { PENDING:'pending', UPLOADING:'uploading', SUCCESS:'success', ERROR:'error' };
  const [folderName, setFolderName] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const [contractKey, setContractKey] = useState(null);

  useEffect(() => {
    if (isOpen) {
      setFiles([]);
      setProgress(0);
      setShowErrorPopup(false);
      setErrorMessage("");
      setIsUploaded(false);
      setIsUploading(false);
      setInvoiceKey(null);
      setFileKey(null);
      setCurrentMessage("Waiting for updates...");
      setWsStatusMessage("Waiting for updates...");
      setContractKey(null);
      setIsInvoiceInsideContract(false);
      setIsContractInsideInvoice(false);
      setIsCreating(false);
      setFolderName("");
    } else {
      setFiles([]);
      setIsUploaded(false);
      setIsCreating(false);
    }
  }, [isOpen]);

  async function startBatchUpload(fileList) {
    const formData = new FormData();
    fileList.forEach(f => formData.append("files", f.file));
    formData.append("folder_name", folderName);

    const token = await getFreshAccessToken();
    const url = `${process.env.REACT_APP_API_URL}api/v1/readpdf/create-folder/`;

    const ws = new WebSocket(`${process.env.REACT_APP_WS_URL}/ws/upload-status/?token=${token}`);

    ws.onmessage = (e) => {
      const d = JSON.parse(e.data);

      setFiles(prevFiles => {
        let alreadyClaimed = false;

        const updatedFiles = prevFiles.map((f, i) => {
          const isKeyMatch = f.key === d.pdf_key;

          const canClaim =
            !alreadyClaimed &&
            !f.key &&
            f.status === STATUS.UPLOADING &&
            d.pdf_key &&
            !prevFiles.some((other, idx) => other.key === d.pdf_key && idx !== i);

          if (!isKeyMatch && !canClaim) return f;

          const patch = {};

          if (canClaim) {
            patch.key = d.pdf_key;
            alreadyClaimed = true;
          }

          if (d.type === "progress") {
            patch.progress = d.progress;
          } else if (d.type === "completed") {
            patch.status = STATUS.SUCCESS;
            patch.progress = 100;
          } else if (d.type === "error") {
            patch.status = STATUS.ERROR;
            patch.progress = 0;
            const msg = d.message?.toLowerCase() || "";

            if (msg.includes("unsupported")) {
              patch.errorReason = "unsupported";
            } else if (msg.includes("duplicate")) {
              patch.errorReason = "duplicate";
            } else if (msg.includes("size") || msg.includes("limit")) {
              patch.errorReason = "size_limit";
            } else {
              patch.errorReason = "unknown";
            }
          }

          return { ...f, ...patch };
        });

        const allDone = updatedFiles.every(
          f => f.status === STATUS.SUCCESS || f.status === STATUS.ERROR
        );
        if (allDone) {
          if (ws.readyState === WebSocket.OPEN) {
            ws.close();
          }
          setIsUploaded(true);
        }
        return updatedFiles;
      });
    };

    try {
      updateAllFilesStatus(STATUS.UPLOADING);

      const resp = await api.post(url, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (ev) => {
          const baseProgress = Math.min(30, Math.round((ev.loaded * 100) / ev.total));
          setFiles(prev => prev.map(f => {
            return { ...f, progress: Math.max(f.progress, baseProgress) };
          }));
        },
      });

      const uploads = resp.data?.uploads || [];

      setFiles(prevFiles =>
        prevFiles.map(f => {
          const upload = uploads.find(u => u.filename === f.file.name);
          return upload && upload.pdf_key
            ? { ...f, key: upload.pdf_key }
            : f;
        })
      );

    } catch (err) {
      console.error("🚨 Batch upload failed:", err);
      setFiles(prev => prev.map(f => ({ ...f, status: STATUS.ERROR })));
      if (ws.readyState === WebSocket.OPEN) {
        ws.close();
      }

      const backendMsg =
        err?.response?.data?.msg || err?.response?.data?.error || "Upload failed.";

      if (backendMsg.toLowerCase().includes("folder name already exists")) {
        toast.error(backendMsg);
        setIsCreating(false);
        setIsUploaded(false);
        return;
      }

      if (
        backendMsg === "Only 5 files allowed" ||
        backendMsg.includes("Trial users can upload only 5 documents")
      ) {
        toast.error(backendMsg);
        setTimeout(() => {
          onClose();
        }, 3000);
      } else {
        toast.error(backendMsg);
        setIsCreating(false);
        setIsUploaded(false);
      }
    }
  }

  function updateAllFilesStatus(status) {
    setFiles(prev => prev.map(f => ({ ...f, status })));
  }

  const handleFileChange = (e) => {
    const picked = Array.from(e.target.files || []);
    if (!picked.length) return;

    const meta = picked.map(f => ({
      file: f,
      progress: 0,
      status: STATUS.PENDING,
      key: null,
      ws: null,
    }));

    const newFiles = [...files, ...meta];
    setFiles(newFiles);
    
    setIsCreating(true);
    setIsUploaded(false);
    
    startBatchUpload(meta);
  };

  const updateFile = (idx, patchOrFn) =>
    setFiles(prev => prev.map((f, i) =>
      i === idx
        ? typeof patchOrFn === "function" ? { ...f, ...patchOrFn(f) } : { ...f, ...patchOrFn }
        : f
    ));

  const showError = (message) => {
    setErrorMessage(message);
    setShowErrorPopup(true);
  };

  if (!isOpen) return null;

  const triggerFileInput = () => {
    if (!folderName.trim()) {
      toast.error("Please enter a folder name first.");
      return;
    }

    if (fileInputRef.current) {
      fileInputRef.current.value = null;
      fileInputRef.current.click();
    }
  };

  const handleClose = () => {
    setFiles([]);
    setIsCreating(false);
    setIsUploaded(false);
    setFolderName("");

    onClose();
    navigate("/uploadFile");
  };

  return (
    <div
      className="modal-backdrop"
      onClick={handleClose}
    >
      {isUploaded ? (
        <div
          className="modal-container-first"
          onClick={(e) => e.stopPropagation()}
        >
          <button className="modal-close" onClick={handleClose}>×</button>
          <h2 className="modal-title">Folder created Successfully</h2>

          <div className="input-group">
            <label htmlFor="folderName">Title *</label>
            <input
              type="text"
              id="folderName"
              value={folderName}
              onChange={(e) => setFolderName(e.target.value)}
              placeholder="Enter here"
            />
          </div>

          <div className="progress-bar-border scrollbar-thin scrollbar-thumb-[rgba(115,96,123,0.4)] scrollbar-track-transparent" 
            style={{ 
              height: Math.min(files.length * 62, 186), 
              maxHeight: "186px", 
              overflowY: files.length * 62 > 186 ? "auto" : "hidden" 
            }}>
            {files.map((f, i) => {
              return (
                <div key={i} className="file-info-success">
                  <div className="file-info-row">
                    <span className="file-name-highlight">
                      {f.file.name.length > 25
                        ? `${f.file.name.slice(0, 20)}...${f.file.name.slice(-10)}`
                        : f.file.name}
                    </span>
                    <span className="tick-icon">
                      {f.status === STATUS.SUCCESS ? (
                        <img src="/right-success-upload.svg" alt="✔" className="status-icon" />
                      ) : (
                        <span className="error-indicator">
                          <img src="/cross-icon.svg" alt="✖" className="status-icon" />
                          {f.status === STATUS.ERROR && (
                            <span className="error-text">
                              {(f.errorReason || "").toLowerCase() === "unsupported"
                                ? "Unsupported file type"
                                : (f.errorReason || "").toLowerCase() === "duplicate"
                                ? "Duplicate file"
                                : (f.errorReason || "").toLowerCase() === "size_limit"
                                ? "File size exceeds limit"
                                : "Upload failed"}
                            </span>
                          )}
                        </span>
                      )}
                    </span>
                  </div>
                  <div className="progress-bar-cont-two">
                    <div
                      className="progress-bar-fill-bar"
                      style={{ width: `${f.progress}%` }}
                    />
                  </div>
                </div>
              );
            })}
          </div>

          <div className="success-actions-custom">
            <div className="center-action">
              <button className="view-docs-btn" onClick={() => handleClose(true)}>Done</button>
            </div>
          </div>
        </div>
      ) : isCreating ? (
        <div className="modal-container-first" onClick={(e) => e.stopPropagation()}>
          <button className="modal-close" onClick={handleClose}>×</button>
          <div className="title-name">
            <h2 className="modal-title">Create a new folder</h2>
          </div>
          <p className="modal-description">
            Name your folder and drag & drop documents to organize them right away
          </p>

          <div className="input-group">
            <label htmlFor="folderName">Title *</label>
            <input type="text" id="folderName" value={folderName} placeholder="Enter here" disabled />
          </div>

          <div className="progress-bar-border bar-border scrollbar-thin scrollbar-thumb-[rgba(115,96,123,0.4)] scrollbar-track-transparent" 
            style={{ 
              height: Math.min(files.length * 65, 195), 
              maxHeight: "195px", 
              overflowY: files.length * 65 > 195 ? "auto" : "hidden" 
            }}>
            {files.map((f, i) => (
              <div key={i} className="upload-row">
                <div className="percetange-label-upload">
                  <span className="file-label">
                    {f.file.name.length > 25 ? `${f.file.name.slice(0, 20)}...${f.file.name.slice(-10)}` : f.file.name}
                  </span>
                  <p className="progress-num">{f.progress}% to complete</p>
                </div>
                <div className="progress-bar-cont">
                  <div className="progress-bar-fill-bar" style={{ width: `${f.progress}%` }} />
                </div>
              </div>
            ))}
          </div>

          <div className="file-format-info">
            <div className="format-text">Supported formats: PDF</div>
            <div className="size-text">Maximum Size: 25 MB</div>
          </div>
        </div>
      ) : (
        <div className="modal-container-two" onClick={(e) => e.stopPropagation()}>
          <button className="modal-close" onClick={handleClose}>×</button>
          <h2 className="modal-title">Create a new folder</h2>
          <p className="modal-description">
            Name your folder and Click to upload your files to organize them right away
          </p>

          <div className="input-group">
            <label htmlFor="folderName">Title *</label>
            <input 
              type="text" 
              id="folderName" 
              value={folderName} 
              onChange={(e) => setFolderName(e.target.value)} 
              placeholder="Enter here" 
            />
          </div>

          <div 
            className={`upload-area ${isDragOver ? "drag-over" : ""}`} 
            onClick={(e) => {
              if (e.target.closest("button")) return;
              if (!folderName.trim()) {
                toast.error("Please enter a folder name first.");
                return;
              }
              triggerFileInput();
            }}
            onDragOver={(e) => {
              e.preventDefault(); 
              setIsDragOver(true);
            }} 
            onDragLeave={(e) => {
              e.preventDefault(); 
              setIsDragOver(false);
            }}
            onDrop={(e) => {
              e.preventDefault();
              setIsDragOver(false);
              if (!folderName.trim()) {
                toast.error("Please enter a folder name first.");
                return;
              }
              const droppedFile = e.dataTransfer.files[0];
              if (droppedFile) {
                handleFileChange({ target: { files: [droppedFile] } });
              }
            }}
          >
            <input
              type="file"
              id="fileInput"
              multiple
              style={{ display: "none" }}
              ref={fileInputRef}
              onChange={handleFileChange}
              disabled={!folderName.trim()}
            />

            <div className="file-placeholder">
              <div className="file-icon-folder">
                <img src="/path-to-file-icon.svg" alt="File Icon" />
                <img src="/uploadSmall.svg" alt="Overlay Icon" className="upload-small-folder" />
              </div>
              <p className="choose-file">
                {folderName.trim() ? (
                  <>Click to upload your files or <span className="choose-file-span">Choose File</span></>
                ) : (
                  <span style={{ color: "black" }}>Enter folder name to enable upload</span>
                )}
              </p>
            </div>
          </div>

          <div className="file-format-info">
            <div className="format-text">Supported formats: PDF</div>
            <div className="size-text">Maximum Size: 25 MB</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateFolderModal;
